import { render, staticRenderFns } from "./UrunTanimla.vue?vue&type=template&id=532e4c31&scoped=true&"
import script from "./UrunTanimla.vue?vue&type=script&lang=js&"
export * from "./UrunTanimla.vue?vue&type=script&lang=js&"
import style1 from "./UrunTanimla.vue?vue&type=style&index=1&id=532e4c31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532e4c31",
  null
  
)

export default component.exports